
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { headerActions, leadAcceptanceActions } from 'actions';
import LeadAcceptanceBody from '../LeadAcceptanceBody';
import ContentLoader from '../../common/loaders/ContentLoader';

import _ from 'lodash';
import { HEADER, APPOINTMENT_STATUS, LEAD_ACCEPTANCE } from '_constants';
import { bindActionCreators } from 'redux';

const headerSettings = {
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  headerTitle: 'A new lead is available',
  hasBackButton: true,
  backButtonIcon: 'close',
  hasNotificationIcon: false,
  headerClassName: 'lead-acceptance-header'
};

class AutoAsignLeadAcceptance extends React.Component {
     static propTypes = {
       setHeader: PropTypes.func.isRequired,
       leadAcceptance: PropTypes.object.isRequired,
       history: PropTypes.object.isRequired,
       match: PropTypes.object.isRequired,
       fetch: PropTypes.func.isRequired,
       userprofile: PropTypes.object.isRequired,
       acceptAutoAssignedLead: PropTypes.func.isRequired,
       showErrorMessage: PropTypes.func.isRequired
     }

     constructor (props) {
       super(props);
       this.state = {
         isLoading: false
       };
     }

     componentDidMount = async () => {
       const routeTo = (this.props.history.length < 2) ? '/dashboard' : 'goback';
       this.props.setHeader(headerSettings);
       const { contactId, opportunityId, appointmentId } = this.props.match.params;
       this.setState({ isLoading: true });
       await this.props.fetch(contactId, opportunityId, appointmentId, true, routeTo);
       this.setState({ isLoading: false });
       await this.IsLeadAccepted();
     }

     IsLeadAccepted () {
       const activeReferral = _.get(this.props.leadAcceptance, 'contact', {});
       const activeAppointment = _.get(this.props.leadAcceptance, 'appointment', {});
       if (!_.isEmpty(activeReferral)) {
         if (!(activeAppointment && activeAppointment.eventStatus && activeAppointment.eventStatus.calendarEventStatusKey === APPOINTMENT_STATUS.TENTATIVE.id)) {
           this.props.showErrorMessage('/notifications', LEAD_ACCEPTANCE.CONFLICT_MESSAGE);
         }
       }
     }

     onAcceptLead = async () => {
       const { contactId, appointmentId } = this.props.match.params;
       const routeTo = (this.props.history.length < 2) ? '/dashboard' : 'goback';
       const acceptLeadDetails = {
         contactId: contactId,
         calendarEventId: appointmentId,
         agentPerId: this.props.userprofile.memberKey
       };
       await this.props.acceptAutoAssignedLead(acceptLeadDetails, routeTo);
       this.props.history.replace(`/referraldetails/${this.props.match.params.contactId}/`);
     }

     render () {
       return (
         this.state.isLoading
           ? <ContentLoader isLoading={this.state.isLoading} />
           : <React.Fragment>
             <div className='lead-notification-container'>
               <LeadAcceptanceBody
                 leadAcceptance={this.props.leadAcceptance}
                 onClickHandler={this.onAcceptLead}
               />
             </div>
           </React.Fragment>
       );
     }
}

const mapStateToProps = state => {
  const { leadAcceptance, userprofile } = state;
  return {
    leadAcceptance,
    userprofile: userprofile || {}
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  fetch: bindActionCreators(leadAcceptanceActions.fetch, dispatch),
  acceptAutoAssignedLead: bindActionCreators(leadAcceptanceActions.acceptAutoAssignedLead, dispatch),
  showErrorMessage: bindActionCreators(leadAcceptanceActions.showErrorMessage, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AutoAsignLeadAcceptance));
